// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/webhooks/v1/webhooks.proto" (package "c1.api.webhooks.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Struct } from "../../../../google/protobuf/struct";
import { Duration } from "../../../../google/protobuf/duration";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookInstance
 */
export interface WebhookInstance {
    /**
     * @generated from protobuf field: string webhook_id = 1
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 5
     */
    expiresAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_attempted_at = 6
     */
    lastAttemptedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 7
     */
    completedAt?: Timestamp;
    /**
     * @generated from protobuf field: int32 attempts = 8
     */
    attempts: number;
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.WebhookInstance.WebhookState state = 9
     */
    state: WebhookInstance_WebhookState;
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.WebhookSource source = 10
     */
    source?: WebhookSource;
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.WebhookSpec spec = 11
     */
    spec?: WebhookSpec;
}
/**
 * @generated from protobuf enum c1.api.webhooks.v1.WebhookInstance.WebhookState
 */
export enum WebhookInstance_WebhookState {
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_RUNNING = 2;
     */
    RUNNING = 2,
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_ERROR = 3;
     */
    ERROR = 3,
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_WAITING_CALLBACK = 4;
     */
    WAITING_CALLBACK = 4,
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_PROCESS_RESPONSE = 5;
     */
    PROCESS_RESPONSE = 5,
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_SUCCESS = 6;
     */
    SUCCESS = 6,
    /**
     * @generated from protobuf enum value: WEBHOOK_STATE_FATAL_ERROR = 7;
     */
    FATAL_ERROR = 7
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.Webhook
 */
export interface Webhook {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 4
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string display_name = 5
     */
    displayName: string;
    /**
     * @generated from protobuf field: string url = 6
     */
    url: string;
    /**
     * @generated from protobuf field: string description = 7
     */
    description: string;
    /**
     * How long to wait for a callback response before timing out.
     * Zero/unset means default (8 days). Maximum 30 days.
     *
     * @generated from protobuf field: google.protobuf.Duration callback_timeout = 8
     */
    callbackTimeout?: Duration;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookRef
 */
export interface WebhookRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookInstanceRef
 */
export interface WebhookInstanceRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string webhook_id = 2
     */
    webhookId: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookSource
 */
export interface WebhookSource {
    /**
     * @generated from protobuf oneof: source
     */
    source: {
        oneofKind: "test";
        /**
         * @generated from protobuf field: c1.api.webhooks.v1.WebhookSource.WebhookSourceTest test = 100
         */
        test: WebhookSource_WebhookSourceTest;
    } | {
        oneofKind: "policyPostAction";
        /**
         * @generated from protobuf field: c1.api.webhooks.v1.WebhookSource.WebhookSourcePolicyPostAction policy_post_action = 101
         */
        policyPostAction: WebhookSource_WebhookSourcePolicyPostAction;
    } | {
        oneofKind: "approvalStep";
        /**
         * @generated from protobuf field: c1.api.webhooks.v1.WebhookSource.WebhookSourceApprovalStep approval_step = 102
         */
        approvalStep: WebhookSource_WebhookSourceApprovalStep;
    } | {
        oneofKind: "provisionStep";
        /**
         * @generated from protobuf field: c1.api.webhooks.v1.WebhookSource.WebhookSourceProvisionStep provision_step = 103
         */
        provisionStep: WebhookSource_WebhookSourceProvisionStep;
    } | {
        oneofKind: "workflowStep";
        /**
         * @generated from protobuf field: c1.api.webhooks.v1.WebhookSource.WebhookSourceWorkflowStep workflow_step = 104
         */
        workflowStep: WebhookSource_WebhookSourceWorkflowStep;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceTest
 */
export interface WebhookSource_WebhookSourceTest {
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourcePolicyPostAction
 */
export interface WebhookSource_WebhookSourcePolicyPostAction {
    /**
     * @generated from protobuf field: string ticket_id = 1
     */
    ticketId: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceApprovalStep
 */
export interface WebhookSource_WebhookSourceApprovalStep {
    /**
     * @generated from protobuf field: string ticket_id = 1
     */
    ticketId: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceProvisionStep
 */
export interface WebhookSource_WebhookSourceProvisionStep {
    /**
     * @generated from protobuf field: string ticket_id = 1
     */
    ticketId: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceWorkflowStep
 */
export interface WebhookSource_WebhookSourceWorkflowStep {
    /**
     * @generated from protobuf field: int64 workflow_execution_id = 1
     */
    workflowExecutionId: number;
    /**
     * @generated from protobuf field: string workflow_step_id = 2
     */
    workflowStepId: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookSpec
 */
export interface WebhookSpec {
    /**
     * @generated from protobuf field: string destination = 1
     */
    destination: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookAttempt
 */
export interface WebhookAttempt {
    /**
     * @generated from protobuf field: string webhook_id = 1
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string id = 3
     */
    id: string;
    /**
     * @generated from protobuf field: int32 attempt = 4
     */
    attempt: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: bytes request = 6
     */
    request: Uint8Array;
    /**
     * @generated from protobuf field: google.protobuf.Struct request_headers = 7
     */
    requestHeaders?: Struct;
    /**
     * @generated from protobuf field: bytes response = 8
     */
    response: Uint8Array;
    /**
     * @generated from protobuf field: int32 response_status_code = 9
     */
    responseStatusCode: number;
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.WebhookAttempt.WebhookResponseTiming response_timing = 10
     */
    responseTiming?: WebhookAttempt_WebhookResponseTiming;
    /**
     * @generated from protobuf field: string msg = 11
     */
    msg: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookAttempt.WebhookResponseTiming
 */
export interface WebhookAttempt_WebhookResponseTiming {
    /**
     * @generated from protobuf field: google.protobuf.Duration total = 1
     */
    total?: Duration;
    /**
     * @generated from protobuf field: google.protobuf.Duration dns_lookup = 2
     */
    dnsLookup?: Duration;
    /**
     * @generated from protobuf field: google.protobuf.Duration tcp_connection = 3
     */
    tcpConnection?: Duration;
    /**
     * @generated from protobuf field: google.protobuf.Duration tls_handshake = 4
     */
    tlsHandshake?: Duration;
    /**
     * @generated from protobuf field: google.protobuf.Duration server_processing = 5
     */
    serverProcessing?: Duration;
    /**
     * @generated from protobuf field: google.protobuf.Duration content_transfer = 6
     */
    contentTransfer?: Duration;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceTestRequest
 */
export interface WebhooksServiceTestRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceTestResponse
 */
export interface WebhooksServiceTestResponse {
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.WebhookInstance webhook = 1
     */
    webhook?: WebhookInstance;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceCreateRequest
 */
export interface WebhooksServiceCreateRequest {
    /**
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf field: string url = 2
     */
    url: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * Callback timeout. Zero/unset means default (8 days). Max 30 days.
     *
     * @generated from protobuf field: google.protobuf.Duration callback_timeout = 4
     */
    callbackTimeout?: Duration;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceCreateResponse
 */
export interface WebhooksServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.Webhook webhook = 1
     */
    webhook?: Webhook;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceAttemptsRequest
 */
export interface WebhooksServiceAttemptsRequest {
    /**
     * @generated from protobuf field: string webhook_id = 1
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceAttemptsResponse
 */
export interface WebhooksServiceAttemptsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.webhooks.v1.WebhookAttempt list = 1
     */
    list: WebhookAttempt[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceGetRequest
 */
export interface WebhooksServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceDeleteRequest
 */
export interface WebhooksServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * Empty response body. Status code indicates success.
 *
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceDeleteResponse
 */
export interface WebhooksServiceDeleteResponse {
}
/**
 * The WebhooksServiceUpdateRequest message contains the webhook object to update and a field mask to indicate which fields to update. It uses URL value for input.
 *
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceUpdateRequest
 */
export interface WebhooksServiceUpdateRequest {
    /**
     * The policy object with the changes to update.
     *
     * @generated from protobuf field: c1.api.webhooks.v1.Webhook webhook = 1
     */
    webhook?: Webhook;
    /**
     * The update mask is a comma-sepparated string of fields to update. This may be something like "webhook_url".
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceUpdateResponse
 */
export interface WebhooksServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.Webhook webhook = 1
     */
    webhook?: Webhook;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceGetResponse
 */
export interface WebhooksServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.Webhook webhook = 1
     */
    webhook?: Webhook;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceListRequest
 */
export interface WebhooksServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksServiceListResponse
 */
export interface WebhooksServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.webhooks.v1.Webhook list = 1
     */
    list: Webhook[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksSearchRequest
 */
export interface WebhooksSearchRequest {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.webhooks.v1.WebhookRef refs = 5
     */
    refs: WebhookRef[];
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhooksSearchResponse
 */
export interface WebhooksSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.webhooks.v1.Webhook list = 1
     */
    list: Webhook[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookInstanceServiceListRequest
 */
export interface WebhookInstanceServiceListRequest {
    /**
     * @generated from protobuf field: string webhook_id = 1
     */
    webhookId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookInstanceServiceListResponse
 */
export interface WebhookInstanceServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.webhooks.v1.WebhookInstance list = 1
     */
    list: WebhookInstance[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookPayload
 */
export interface WebhookPayload {
    /**
     * @generated from protobuf field: string webhook_id = 1
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 6
     */
    expiresAt?: Timestamp;
    /**
     * zstd compressed payload body, a Protobuf Any message which we unmarshal
     * to create a WebhookAttempt with the per-Attempt body.
     *
     * @generated from protobuf field: string payload = 7
     */
    payload: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookInstancePayloadGetRequest
 */
export interface WebhookInstancePayloadGetRequest {
    /**
     * @generated from protobuf field: string webhook_id = 1
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2
     */
    webhookInstanceId: string;
}
/**
 * @generated from protobuf message c1.api.webhooks.v1.WebhookInstancePayloadGetResponse
 */
export interface WebhookInstancePayloadGetResponse {
    /**
     * @generated from protobuf field: c1.api.webhooks.v1.WebhookPayload payload = 1
     */
    payload?: WebhookPayload;
}
// @generated message type with reflection information, may provide speed optimized methods
class WebhookInstance$Type extends MessageType<WebhookInstance> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookInstance", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "expires_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "last_attempted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "completed_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "attempts", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "state", kind: "enum", T: () => ["c1.api.webhooks.v1.WebhookInstance.WebhookState", WebhookInstance_WebhookState, "WEBHOOK_STATE_"] },
            { no: 10, name: "source", kind: "message", T: () => WebhookSource },
            { no: 11, name: "spec", kind: "message", T: () => WebhookSpec }
        ]);
    }
    create(value?: PartialMessage<WebhookInstance>): WebhookInstance {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookId = "";
        message.id = "";
        message.attempts = 0;
        message.state = 0;
        if (value !== undefined)
            reflectionMergePartial<WebhookInstance>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookInstance): WebhookInstance {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 5:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* google.protobuf.Timestamp last_attempted_at */ 6:
                    message.lastAttemptedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastAttemptedAt);
                    break;
                case /* google.protobuf.Timestamp completed_at */ 7:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* int32 attempts */ 8:
                    message.attempts = reader.int32();
                    break;
                case /* c1.api.webhooks.v1.WebhookInstance.WebhookState state */ 9:
                    message.state = reader.int32();
                    break;
                case /* c1.api.webhooks.v1.WebhookSource source */ 10:
                    message.source = WebhookSource.internalBinaryRead(reader, reader.uint32(), options, message.source);
                    break;
                case /* c1.api.webhooks.v1.WebhookSpec spec */ 11:
                    message.spec = WebhookSpec.internalBinaryRead(reader, reader.uint32(), options, message.spec);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookInstance, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_at = 5; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_attempted_at = 6; */
        if (message.lastAttemptedAt)
            Timestamp.internalBinaryWrite(message.lastAttemptedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp completed_at = 7; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* int32 attempts = 8; */
        if (message.attempts !== 0)
            writer.tag(8, WireType.Varint).int32(message.attempts);
        /* c1.api.webhooks.v1.WebhookInstance.WebhookState state = 9; */
        if (message.state !== 0)
            writer.tag(9, WireType.Varint).int32(message.state);
        /* c1.api.webhooks.v1.WebhookSource source = 10; */
        if (message.source)
            WebhookSource.internalBinaryWrite(message.source, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.webhooks.v1.WebhookSpec spec = 11; */
        if (message.spec)
            WebhookSpec.internalBinaryWrite(message.spec, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookInstance
 */
export const WebhookInstance = new WebhookInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Webhook$Type extends MessageType<Webhook> {
    constructor() {
        super("c1.api.webhooks.v1.Webhook", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "callback_timeout", kind: "message", T: () => Duration }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Webhook" } }] }, "policy.v1.msg": { enabled: true, name: "webhook", keyFields: ["id"] } });
    }
    create(value?: PartialMessage<Webhook>): Webhook {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.url = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<Webhook>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Webhook): Webhook {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 4:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string display_name */ 5:
                    message.displayName = reader.string();
                    break;
                case /* string url */ 6:
                    message.url = reader.string();
                    break;
                case /* string description */ 7:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Duration callback_timeout */ 8:
                    message.callbackTimeout = Duration.internalBinaryRead(reader, reader.uint32(), options, message.callbackTimeout);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Webhook, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 4; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 5; */
        if (message.displayName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.displayName);
        /* string url = 6; */
        if (message.url !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.url);
        /* string description = 7; */
        if (message.description !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Duration callback_timeout = 8; */
        if (message.callbackTimeout)
            Duration.internalBinaryWrite(message.callbackTimeout, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.Webhook
 */
export const Webhook = new Webhook$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookRef$Type extends MessageType<WebhookRef> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<WebhookRef>): WebhookRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<WebhookRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookRef): WebhookRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookRef
 */
export const WebhookRef = new WebhookRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookInstanceRef$Type extends MessageType<WebhookInstanceRef> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookInstanceRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<WebhookInstanceRef>): WebhookInstanceRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.webhookId = "";
        if (value !== undefined)
            reflectionMergePartial<WebhookInstanceRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookInstanceRef): WebhookInstanceRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string webhook_id */ 2:
                    message.webhookId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookInstanceRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string webhook_id = 2; */
        if (message.webhookId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookInstanceRef
 */
export const WebhookInstanceRef = new WebhookInstanceRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookSource$Type extends MessageType<WebhookSource> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookSource", [
            { no: 100, name: "test", kind: "message", oneof: "source", T: () => WebhookSource_WebhookSourceTest },
            { no: 101, name: "policy_post_action", kind: "message", oneof: "source", T: () => WebhookSource_WebhookSourcePolicyPostAction },
            { no: 102, name: "approval_step", kind: "message", oneof: "source", T: () => WebhookSource_WebhookSourceApprovalStep },
            { no: 103, name: "provision_step", kind: "message", oneof: "source", T: () => WebhookSource_WebhookSourceProvisionStep },
            { no: 104, name: "workflow_step", kind: "message", oneof: "source", T: () => WebhookSource_WebhookSourceWorkflowStep }
        ]);
    }
    create(value?: PartialMessage<WebhookSource>): WebhookSource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.source = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<WebhookSource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookSource): WebhookSource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.webhooks.v1.WebhookSource.WebhookSourceTest test */ 100:
                    message.source = {
                        oneofKind: "test",
                        test: WebhookSource_WebhookSourceTest.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).test)
                    };
                    break;
                case /* c1.api.webhooks.v1.WebhookSource.WebhookSourcePolicyPostAction policy_post_action */ 101:
                    message.source = {
                        oneofKind: "policyPostAction",
                        policyPostAction: WebhookSource_WebhookSourcePolicyPostAction.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).policyPostAction)
                    };
                    break;
                case /* c1.api.webhooks.v1.WebhookSource.WebhookSourceApprovalStep approval_step */ 102:
                    message.source = {
                        oneofKind: "approvalStep",
                        approvalStep: WebhookSource_WebhookSourceApprovalStep.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).approvalStep)
                    };
                    break;
                case /* c1.api.webhooks.v1.WebhookSource.WebhookSourceProvisionStep provision_step */ 103:
                    message.source = {
                        oneofKind: "provisionStep",
                        provisionStep: WebhookSource_WebhookSourceProvisionStep.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).provisionStep)
                    };
                    break;
                case /* c1.api.webhooks.v1.WebhookSource.WebhookSourceWorkflowStep workflow_step */ 104:
                    message.source = {
                        oneofKind: "workflowStep",
                        workflowStep: WebhookSource_WebhookSourceWorkflowStep.internalBinaryRead(reader, reader.uint32(), options, (message.source as any).workflowStep)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookSource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.webhooks.v1.WebhookSource.WebhookSourceTest test = 100; */
        if (message.source.oneofKind === "test")
            WebhookSource_WebhookSourceTest.internalBinaryWrite(message.source.test, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.webhooks.v1.WebhookSource.WebhookSourcePolicyPostAction policy_post_action = 101; */
        if (message.source.oneofKind === "policyPostAction")
            WebhookSource_WebhookSourcePolicyPostAction.internalBinaryWrite(message.source.policyPostAction, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.webhooks.v1.WebhookSource.WebhookSourceApprovalStep approval_step = 102; */
        if (message.source.oneofKind === "approvalStep")
            WebhookSource_WebhookSourceApprovalStep.internalBinaryWrite(message.source.approvalStep, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.webhooks.v1.WebhookSource.WebhookSourceProvisionStep provision_step = 103; */
        if (message.source.oneofKind === "provisionStep")
            WebhookSource_WebhookSourceProvisionStep.internalBinaryWrite(message.source.provisionStep, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.webhooks.v1.WebhookSource.WebhookSourceWorkflowStep workflow_step = 104; */
        if (message.source.oneofKind === "workflowStep")
            WebhookSource_WebhookSourceWorkflowStep.internalBinaryWrite(message.source.workflowStep, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookSource
 */
export const WebhookSource = new WebhookSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookSource_WebhookSourceTest$Type extends MessageType<WebhookSource_WebhookSourceTest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookSource.WebhookSourceTest", []);
    }
    create(value?: PartialMessage<WebhookSource_WebhookSourceTest>): WebhookSource_WebhookSourceTest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WebhookSource_WebhookSourceTest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookSource_WebhookSourceTest): WebhookSource_WebhookSourceTest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookSource_WebhookSourceTest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceTest
 */
export const WebhookSource_WebhookSourceTest = new WebhookSource_WebhookSourceTest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookSource_WebhookSourcePolicyPostAction$Type extends MessageType<WebhookSource_WebhookSourcePolicyPostAction> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookSource.WebhookSourcePolicyPostAction", [
            { no: 1, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WebhookSource_WebhookSourcePolicyPostAction>): WebhookSource_WebhookSourcePolicyPostAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ticketId = "";
        if (value !== undefined)
            reflectionMergePartial<WebhookSource_WebhookSourcePolicyPostAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookSource_WebhookSourcePolicyPostAction): WebhookSource_WebhookSourcePolicyPostAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string ticket_id */ 1:
                    message.ticketId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookSource_WebhookSourcePolicyPostAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string ticket_id = 1; */
        if (message.ticketId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.ticketId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourcePolicyPostAction
 */
export const WebhookSource_WebhookSourcePolicyPostAction = new WebhookSource_WebhookSourcePolicyPostAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookSource_WebhookSourceApprovalStep$Type extends MessageType<WebhookSource_WebhookSourceApprovalStep> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookSource.WebhookSourceApprovalStep", [
            { no: 1, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WebhookSource_WebhookSourceApprovalStep>): WebhookSource_WebhookSourceApprovalStep {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ticketId = "";
        if (value !== undefined)
            reflectionMergePartial<WebhookSource_WebhookSourceApprovalStep>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookSource_WebhookSourceApprovalStep): WebhookSource_WebhookSourceApprovalStep {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string ticket_id */ 1:
                    message.ticketId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookSource_WebhookSourceApprovalStep, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string ticket_id = 1; */
        if (message.ticketId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.ticketId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceApprovalStep
 */
export const WebhookSource_WebhookSourceApprovalStep = new WebhookSource_WebhookSourceApprovalStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookSource_WebhookSourceProvisionStep$Type extends MessageType<WebhookSource_WebhookSourceProvisionStep> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookSource.WebhookSourceProvisionStep", [
            { no: 1, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WebhookSource_WebhookSourceProvisionStep>): WebhookSource_WebhookSourceProvisionStep {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ticketId = "";
        if (value !== undefined)
            reflectionMergePartial<WebhookSource_WebhookSourceProvisionStep>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookSource_WebhookSourceProvisionStep): WebhookSource_WebhookSourceProvisionStep {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string ticket_id */ 1:
                    message.ticketId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookSource_WebhookSourceProvisionStep, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string ticket_id = 1; */
        if (message.ticketId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.ticketId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceProvisionStep
 */
export const WebhookSource_WebhookSourceProvisionStep = new WebhookSource_WebhookSourceProvisionStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookSource_WebhookSourceWorkflowStep$Type extends MessageType<WebhookSource_WebhookSourceWorkflowStep> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookSource.WebhookSourceWorkflowStep", [
            { no: 1, name: "workflow_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "workflow_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WebhookSource_WebhookSourceWorkflowStep>): WebhookSource_WebhookSourceWorkflowStep {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.workflowExecutionId = 0;
        message.workflowStepId = "";
        if (value !== undefined)
            reflectionMergePartial<WebhookSource_WebhookSourceWorkflowStep>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookSource_WebhookSourceWorkflowStep): WebhookSource_WebhookSourceWorkflowStep {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 workflow_execution_id */ 1:
                    message.workflowExecutionId = reader.int64().toNumber();
                    break;
                case /* string workflow_step_id */ 2:
                    message.workflowStepId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookSource_WebhookSourceWorkflowStep, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 workflow_execution_id = 1; */
        if (message.workflowExecutionId !== 0)
            writer.tag(1, WireType.Varint).int64(message.workflowExecutionId);
        /* string workflow_step_id = 2; */
        if (message.workflowStepId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workflowStepId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookSource.WebhookSourceWorkflowStep
 */
export const WebhookSource_WebhookSourceWorkflowStep = new WebhookSource_WebhookSourceWorkflowStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookSpec$Type extends MessageType<WebhookSpec> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookSpec", [
            { no: 1, name: "destination", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WebhookSpec>): WebhookSpec {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.destination = "";
        if (value !== undefined)
            reflectionMergePartial<WebhookSpec>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookSpec): WebhookSpec {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string destination */ 1:
                    message.destination = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookSpec, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string destination = 1; */
        if (message.destination !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.destination);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookSpec
 */
export const WebhookSpec = new WebhookSpec$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookAttempt$Type extends MessageType<WebhookAttempt> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookAttempt", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "attempt", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "request", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 7, name: "request_headers", kind: "message", T: () => Struct },
            { no: 8, name: "response", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 9, name: "response_status_code", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "response_timing", kind: "message", T: () => WebhookAttempt_WebhookResponseTiming },
            { no: 11, name: "msg", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WebhookAttempt>): WebhookAttempt {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookId = "";
        message.webhookInstanceId = "";
        message.id = "";
        message.attempt = 0;
        message.request = new Uint8Array(0);
        message.response = new Uint8Array(0);
        message.responseStatusCode = 0;
        message.msg = "";
        if (value !== undefined)
            reflectionMergePartial<WebhookAttempt>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookAttempt): WebhookAttempt {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookId = reader.string();
                    break;
                case /* string webhook_instance_id */ 2:
                    message.webhookInstanceId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                case /* int32 attempt */ 4:
                    message.attempt = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* bytes request */ 6:
                    message.request = reader.bytes();
                    break;
                case /* google.protobuf.Struct request_headers */ 7:
                    message.requestHeaders = Struct.internalBinaryRead(reader, reader.uint32(), options, message.requestHeaders);
                    break;
                case /* bytes response */ 8:
                    message.response = reader.bytes();
                    break;
                case /* int32 response_status_code */ 9:
                    message.responseStatusCode = reader.int32();
                    break;
                case /* c1.api.webhooks.v1.WebhookAttempt.WebhookResponseTiming response_timing */ 10:
                    message.responseTiming = WebhookAttempt_WebhookResponseTiming.internalBinaryRead(reader, reader.uint32(), options, message.responseTiming);
                    break;
                case /* string msg */ 11:
                    message.msg = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookAttempt, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookId);
        /* string webhook_instance_id = 2; */
        if (message.webhookInstanceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookInstanceId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        /* int32 attempt = 4; */
        if (message.attempt !== 0)
            writer.tag(4, WireType.Varint).int32(message.attempt);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bytes request = 6; */
        if (message.request.length)
            writer.tag(6, WireType.LengthDelimited).bytes(message.request);
        /* google.protobuf.Struct request_headers = 7; */
        if (message.requestHeaders)
            Struct.internalBinaryWrite(message.requestHeaders, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bytes response = 8; */
        if (message.response.length)
            writer.tag(8, WireType.LengthDelimited).bytes(message.response);
        /* int32 response_status_code = 9; */
        if (message.responseStatusCode !== 0)
            writer.tag(9, WireType.Varint).int32(message.responseStatusCode);
        /* c1.api.webhooks.v1.WebhookAttempt.WebhookResponseTiming response_timing = 10; */
        if (message.responseTiming)
            WebhookAttempt_WebhookResponseTiming.internalBinaryWrite(message.responseTiming, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string msg = 11; */
        if (message.msg !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.msg);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookAttempt
 */
export const WebhookAttempt = new WebhookAttempt$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookAttempt_WebhookResponseTiming$Type extends MessageType<WebhookAttempt_WebhookResponseTiming> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookAttempt.WebhookResponseTiming", [
            { no: 1, name: "total", kind: "message", T: () => Duration },
            { no: 2, name: "dns_lookup", kind: "message", T: () => Duration },
            { no: 3, name: "tcp_connection", kind: "message", T: () => Duration },
            { no: 4, name: "tls_handshake", kind: "message", T: () => Duration },
            { no: 5, name: "server_processing", kind: "message", T: () => Duration },
            { no: 6, name: "content_transfer", kind: "message", T: () => Duration }
        ]);
    }
    create(value?: PartialMessage<WebhookAttempt_WebhookResponseTiming>): WebhookAttempt_WebhookResponseTiming {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WebhookAttempt_WebhookResponseTiming>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookAttempt_WebhookResponseTiming): WebhookAttempt_WebhookResponseTiming {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Duration total */ 1:
                    message.total = Duration.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* google.protobuf.Duration dns_lookup */ 2:
                    message.dnsLookup = Duration.internalBinaryRead(reader, reader.uint32(), options, message.dnsLookup);
                    break;
                case /* google.protobuf.Duration tcp_connection */ 3:
                    message.tcpConnection = Duration.internalBinaryRead(reader, reader.uint32(), options, message.tcpConnection);
                    break;
                case /* google.protobuf.Duration tls_handshake */ 4:
                    message.tlsHandshake = Duration.internalBinaryRead(reader, reader.uint32(), options, message.tlsHandshake);
                    break;
                case /* google.protobuf.Duration server_processing */ 5:
                    message.serverProcessing = Duration.internalBinaryRead(reader, reader.uint32(), options, message.serverProcessing);
                    break;
                case /* google.protobuf.Duration content_transfer */ 6:
                    message.contentTransfer = Duration.internalBinaryRead(reader, reader.uint32(), options, message.contentTransfer);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookAttempt_WebhookResponseTiming, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Duration total = 1; */
        if (message.total)
            Duration.internalBinaryWrite(message.total, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration dns_lookup = 2; */
        if (message.dnsLookup)
            Duration.internalBinaryWrite(message.dnsLookup, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration tcp_connection = 3; */
        if (message.tcpConnection)
            Duration.internalBinaryWrite(message.tcpConnection, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration tls_handshake = 4; */
        if (message.tlsHandshake)
            Duration.internalBinaryWrite(message.tlsHandshake, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration server_processing = 5; */
        if (message.serverProcessing)
            Duration.internalBinaryWrite(message.serverProcessing, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration content_transfer = 6; */
        if (message.contentTransfer)
            Duration.internalBinaryWrite(message.contentTransfer, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookAttempt.WebhookResponseTiming
 */
export const WebhookAttempt_WebhookResponseTiming = new WebhookAttempt_WebhookResponseTiming$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceTestRequest$Type extends MessageType<WebhooksServiceTestRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceTestRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<WebhooksServiceTestRequest>): WebhooksServiceTestRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<WebhooksServiceTestRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksServiceTestRequest): WebhooksServiceTestRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksServiceTestRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceTestRequest
 */
export const WebhooksServiceTestRequest = new WebhooksServiceTestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceTestResponse$Type extends MessageType<WebhooksServiceTestResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceTestResponse", [
            { no: 1, name: "webhook", kind: "message", T: () => WebhookInstance }
        ]);
    }
    create(value?: PartialMessage<WebhooksServiceTestResponse>): WebhooksServiceTestResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WebhooksServiceTestResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksServiceTestResponse): WebhooksServiceTestResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.webhooks.v1.WebhookInstance webhook */ 1:
                    message.webhook = WebhookInstance.internalBinaryRead(reader, reader.uint32(), options, message.webhook);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksServiceTestResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.webhooks.v1.WebhookInstance webhook = 1; */
        if (message.webhook)
            WebhookInstance.internalBinaryWrite(message.webhook, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceTestResponse
 */
export const WebhooksServiceTestResponse = new WebhooksServiceTestResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceCreateRequest$Type extends MessageType<WebhooksServiceCreateRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { minLen: "3", maxLen: "100" } } } },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { minLen: "3", maxLen: "2048" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "0", maxLen: "200" } } } },
            { no: 4, name: "callback_timeout", kind: "message", T: () => Duration, options: { "validate.rules": { duration: { lte: { seconds: "2592000" }, gte: {} } } } }
        ]);
    }
    create(value?: PartialMessage<WebhooksServiceCreateRequest>): WebhooksServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.url = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<WebhooksServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksServiceCreateRequest): WebhooksServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string url */ 2:
                    message.url = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Duration callback_timeout */ 4:
                    message.callbackTimeout = Duration.internalBinaryRead(reader, reader.uint32(), options, message.callbackTimeout);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string url = 2; */
        if (message.url !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.url);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Duration callback_timeout = 4; */
        if (message.callbackTimeout)
            Duration.internalBinaryWrite(message.callbackTimeout, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceCreateRequest
 */
export const WebhooksServiceCreateRequest = new WebhooksServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceCreateResponse$Type extends MessageType<WebhooksServiceCreateResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceCreateResponse", [
            { no: 1, name: "webhook", kind: "message", T: () => Webhook }
        ]);
    }
    create(value?: PartialMessage<WebhooksServiceCreateResponse>): WebhooksServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WebhooksServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksServiceCreateResponse): WebhooksServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.webhooks.v1.Webhook webhook */ 1:
                    message.webhook = Webhook.internalBinaryRead(reader, reader.uint32(), options, message.webhook);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.webhooks.v1.Webhook webhook = 1; */
        if (message.webhook)
            Webhook.internalBinaryWrite(message.webhook, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceCreateResponse
 */
export const WebhooksServiceCreateResponse = new WebhooksServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceAttemptsRequest$Type extends MessageType<WebhooksServiceAttemptsRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceAttemptsRequest", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<WebhooksServiceAttemptsRequest>): WebhooksServiceAttemptsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookId = "";
        message.webhookInstanceId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<WebhooksServiceAttemptsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksServiceAttemptsRequest): WebhooksServiceAttemptsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookId = reader.string();
                    break;
                case /* string webhook_instance_id */ 2:
                    message.webhookInstanceId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksServiceAttemptsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookId);
        /* string webhook_instance_id = 2; */
        if (message.webhookInstanceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookInstanceId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceAttemptsRequest
 */
export const WebhooksServiceAttemptsRequest = new WebhooksServiceAttemptsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceAttemptsResponse$Type extends MessageType<WebhooksServiceAttemptsResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceAttemptsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WebhookAttempt },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WebhooksServiceAttemptsResponse>): WebhooksServiceAttemptsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<WebhooksServiceAttemptsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksServiceAttemptsResponse): WebhooksServiceAttemptsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.webhooks.v1.WebhookAttempt list */ 1:
                    message.list.push(WebhookAttempt.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksServiceAttemptsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.webhooks.v1.WebhookAttempt list = 1; */
        for (let i = 0; i < message.list.length; i++)
            WebhookAttempt.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceAttemptsResponse
 */
export const WebhooksServiceAttemptsResponse = new WebhooksServiceAttemptsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceGetRequest$Type extends MessageType<WebhooksServiceGetRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<WebhooksServiceGetRequest>): WebhooksServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<WebhooksServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksServiceGetRequest): WebhooksServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceGetRequest
 */
export const WebhooksServiceGetRequest = new WebhooksServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceDeleteRequest$Type extends MessageType<WebhooksServiceDeleteRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<WebhooksServiceDeleteRequest>): WebhooksServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<WebhooksServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksServiceDeleteRequest): WebhooksServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceDeleteRequest
 */
export const WebhooksServiceDeleteRequest = new WebhooksServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceDeleteResponse$Type extends MessageType<WebhooksServiceDeleteResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<WebhooksServiceDeleteResponse>): WebhooksServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WebhooksServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksServiceDeleteResponse): WebhooksServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceDeleteResponse
 */
export const WebhooksServiceDeleteResponse = new WebhooksServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceUpdateRequest$Type extends MessageType<WebhooksServiceUpdateRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceUpdateRequest", [
            { no: 1, name: "webhook", kind: "message", T: () => Webhook },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<WebhooksServiceUpdateRequest>): WebhooksServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WebhooksServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksServiceUpdateRequest): WebhooksServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.webhooks.v1.Webhook webhook */ 1:
                    message.webhook = Webhook.internalBinaryRead(reader, reader.uint32(), options, message.webhook);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.webhooks.v1.Webhook webhook = 1; */
        if (message.webhook)
            Webhook.internalBinaryWrite(message.webhook, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceUpdateRequest
 */
export const WebhooksServiceUpdateRequest = new WebhooksServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceUpdateResponse$Type extends MessageType<WebhooksServiceUpdateResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceUpdateResponse", [
            { no: 1, name: "webhook", kind: "message", T: () => Webhook }
        ]);
    }
    create(value?: PartialMessage<WebhooksServiceUpdateResponse>): WebhooksServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WebhooksServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksServiceUpdateResponse): WebhooksServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.webhooks.v1.Webhook webhook */ 1:
                    message.webhook = Webhook.internalBinaryRead(reader, reader.uint32(), options, message.webhook);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.webhooks.v1.Webhook webhook = 1; */
        if (message.webhook)
            Webhook.internalBinaryWrite(message.webhook, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceUpdateResponse
 */
export const WebhooksServiceUpdateResponse = new WebhooksServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceGetResponse$Type extends MessageType<WebhooksServiceGetResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceGetResponse", [
            { no: 1, name: "webhook", kind: "message", T: () => Webhook }
        ]);
    }
    create(value?: PartialMessage<WebhooksServiceGetResponse>): WebhooksServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WebhooksServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksServiceGetResponse): WebhooksServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.webhooks.v1.Webhook webhook */ 1:
                    message.webhook = Webhook.internalBinaryRead(reader, reader.uint32(), options, message.webhook);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.webhooks.v1.Webhook webhook = 1; */
        if (message.webhook)
            Webhook.internalBinaryWrite(message.webhook, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceGetResponse
 */
export const WebhooksServiceGetResponse = new WebhooksServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceListRequest$Type extends MessageType<WebhooksServiceListRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<WebhooksServiceListRequest>): WebhooksServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<WebhooksServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksServiceListRequest): WebhooksServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceListRequest
 */
export const WebhooksServiceListRequest = new WebhooksServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksServiceListResponse$Type extends MessageType<WebhooksServiceListResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Webhook },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WebhooksServiceListResponse>): WebhooksServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<WebhooksServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksServiceListResponse): WebhooksServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.webhooks.v1.Webhook list */ 1:
                    message.list.push(Webhook.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.webhooks.v1.Webhook list = 1; */
        for (let i = 0; i < message.list.length; i++)
            Webhook.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksServiceListResponse
 */
export const WebhooksServiceListResponse = new WebhooksServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksSearchRequest$Type extends MessageType<WebhooksSearchRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WebhookRef }
        ]);
    }
    create(value?: PartialMessage<WebhooksSearchRequest>): WebhooksSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<WebhooksSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksSearchRequest): WebhooksSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.webhooks.v1.WebhookRef refs */ 5:
                    message.refs.push(WebhookRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.webhooks.v1.WebhookRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            WebhookRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksSearchRequest
 */
export const WebhooksSearchRequest = new WebhooksSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhooksSearchResponse$Type extends MessageType<WebhooksSearchResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhooksSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Webhook },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WebhooksSearchResponse>): WebhooksSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<WebhooksSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhooksSearchResponse): WebhooksSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.webhooks.v1.Webhook list */ 1:
                    message.list.push(Webhook.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhooksSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.webhooks.v1.Webhook list = 1; */
        for (let i = 0; i < message.list.length; i++)
            Webhook.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhooksSearchResponse
 */
export const WebhooksSearchResponse = new WebhooksSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookInstanceServiceListRequest$Type extends MessageType<WebhookInstanceServiceListRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookInstanceServiceListRequest", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<WebhookInstanceServiceListRequest>): WebhookInstanceServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<WebhookInstanceServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookInstanceServiceListRequest): WebhookInstanceServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookInstanceServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookInstanceServiceListRequest
 */
export const WebhookInstanceServiceListRequest = new WebhookInstanceServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookInstanceServiceListResponse$Type extends MessageType<WebhookInstanceServiceListResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookInstanceServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WebhookInstance },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WebhookInstanceServiceListResponse>): WebhookInstanceServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<WebhookInstanceServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookInstanceServiceListResponse): WebhookInstanceServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.webhooks.v1.WebhookInstance list */ 1:
                    message.list.push(WebhookInstance.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookInstanceServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.webhooks.v1.WebhookInstance list = 1; */
        for (let i = 0; i < message.list.length; i++)
            WebhookInstance.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookInstanceServiceListResponse
 */
export const WebhookInstanceServiceListResponse = new WebhookInstanceServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookPayload$Type extends MessageType<WebhookPayload> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookPayload", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "payload", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WebhookPayload>): WebhookPayload {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookId = "";
        message.webhookInstanceId = "";
        message.payload = "";
        if (value !== undefined)
            reflectionMergePartial<WebhookPayload>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookPayload): WebhookPayload {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookId = reader.string();
                    break;
                case /* string webhook_instance_id */ 2:
                    message.webhookInstanceId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 6:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* string payload */ 7:
                    message.payload = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookPayload, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookId);
        /* string webhook_instance_id = 2; */
        if (message.webhookInstanceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookInstanceId);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_at = 6; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string payload = 7; */
        if (message.payload !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.payload);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookPayload
 */
export const WebhookPayload = new WebhookPayload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookInstancePayloadGetRequest$Type extends MessageType<WebhookInstancePayloadGetRequest> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookInstancePayloadGetRequest", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<WebhookInstancePayloadGetRequest>): WebhookInstancePayloadGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.webhookId = "";
        message.webhookInstanceId = "";
        if (value !== undefined)
            reflectionMergePartial<WebhookInstancePayloadGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookInstancePayloadGetRequest): WebhookInstancePayloadGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string webhook_id */ 1:
                    message.webhookId = reader.string();
                    break;
                case /* string webhook_instance_id */ 2:
                    message.webhookInstanceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookInstancePayloadGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string webhook_id = 1; */
        if (message.webhookId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.webhookId);
        /* string webhook_instance_id = 2; */
        if (message.webhookInstanceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.webhookInstanceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookInstancePayloadGetRequest
 */
export const WebhookInstancePayloadGetRequest = new WebhookInstancePayloadGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookInstancePayloadGetResponse$Type extends MessageType<WebhookInstancePayloadGetResponse> {
    constructor() {
        super("c1.api.webhooks.v1.WebhookInstancePayloadGetResponse", [
            { no: 1, name: "payload", kind: "message", T: () => WebhookPayload }
        ]);
    }
    create(value?: PartialMessage<WebhookInstancePayloadGetResponse>): WebhookInstancePayloadGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WebhookInstancePayloadGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebhookInstancePayloadGetResponse): WebhookInstancePayloadGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.webhooks.v1.WebhookPayload payload */ 1:
                    message.payload = WebhookPayload.internalBinaryRead(reader, reader.uint32(), options, message.payload);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebhookInstancePayloadGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.webhooks.v1.WebhookPayload payload = 1; */
        if (message.payload)
            WebhookPayload.internalBinaryWrite(message.payload, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.webhooks.v1.WebhookInstancePayloadGetResponse
 */
export const WebhookInstancePayloadGetResponse = new WebhookInstancePayloadGetResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.webhooks.v1.WebhooksService
 */
export const WebhooksService = new ServiceType("c1.api.webhooks.v1.WebhooksService", [
    { name: "Get", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/webhooks/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Webhook", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Webhook" }] }, "authz.method": { role: "VIEWER" } }, I: WebhooksServiceGetRequest, O: WebhooksServiceGetResponse },
    { name: "Delete", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/webhooks/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Webhook" }], group: "Webhook" }] }, "authz.method": { role: "EDITOR" } }, I: WebhooksServiceDeleteRequest, O: WebhooksServiceDeleteResponse },
    { name: "Test", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/webhooks/{id}/test", group: "Webhook" }] }, "authz.method": { role: "EDITOR" } }, I: WebhooksServiceTestRequest, O: WebhooksServiceTestResponse },
    { name: "List", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/webhooks", query: { page_size: "page_size", page_token: "page_token" }, group: "Webhook" }] }, "authz.method": { role: "VIEWER" } }, I: WebhooksServiceListRequest, O: WebhooksServiceListResponse },
    { name: "Attempts", options: { "authz.method": { role: "VIEWER" } }, I: WebhooksServiceAttemptsRequest, O: WebhooksServiceAttemptsResponse },
    { name: "Create", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/webhooks", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Webhook" }], group: "Webhook" }] }, "authz.method": { role: "EDITOR" } }, I: WebhooksServiceCreateRequest, O: WebhooksServiceCreateResponse },
    { name: "Update", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/webhooks/{webhook.id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Webhook" }], group: "Webhook" }] }, "authz.method": { role: "EDITOR" } }, I: WebhooksServiceUpdateRequest, O: WebhooksServiceUpdateResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.webhooks.v1.WebhooksSearch
 */
export const WebhooksSearch = new ServiceType("c1.api.webhooks.v1.WebhooksSearch", [
    { name: "Search", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/webhooks", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Webhook", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }, { type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Webhooks", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Webhook", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", in: "TERRAFORM_ENTITY_PAGINATION_INPUT_IN_REQUEST_BODY", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] }, "authz.method": { role: "VIEWER" } }, I: WebhooksSearchRequest, O: WebhooksSearchResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.webhooks.v1.WebhookInstanceService
 */
export const WebhookInstanceService = new ServiceType("c1.api.webhooks.v1.WebhookInstanceService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: WebhookInstanceServiceListRequest, O: WebhookInstanceServiceListResponse },
    { name: "GetPayload", options: { "authz.method": { role: "VIEWER" } }, I: WebhookInstancePayloadGetRequest, O: WebhookInstancePayloadGetResponse }
]);
